// File: src/styles/codeBlockStyles.ts

import {SxProps, Theme} from '@mui/material/styles';

export const codeBlockStyles: SxProps<Theme> = {
    fontFamily: 'JetBrains Mono, Consolas, Monaco, "Courier New", monospace',
    fontSize: '13px',
    lineHeight: 1.5,
    color: 'text.primary',
    backgroundColor: 'rgba(20, 20, 20, 0.8)',
    border: '1px solid #404040',
    borderRadius: 1,
    p: 2,
    overflow: 'auto',
    backdropFilter: 'blur(8px)',
    transition: 'all 0.3s ease',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    margin: 0,
    '&:hover': {
        borderColor: 'primary.main',
        boxShadow: '0 4px 16px rgba(255, 151, 0, 0.15)',
        backgroundColor: 'rgba(25, 25, 25, 0.9)',
    },
    // JSON syntax highlighting
    '& .token.property': {
        color: '#9CDCFE',
    },
    '& .token.string': {
        color: '#CE9178',
    },
    '& .token.number': {
        color: '#B5CEA8',
    },
    '& .token.boolean': {
        color: '#569CD6',
    },
    '& .token.null': {
        color: '#569CD6',
    },
};
